import { IStringMap } from 'app/interfaces/IStringMap';


export enum TriggerTypeOptions {
    Scheduled = 'ScheduleTrigger',
    TumblingWindow = 'TumblingWindowTrigger',
    StorageEvent = 'BlobEventsTrigger',
    Chaining = 'ChainingTrigger',
    RerunTumblingWindowTrigger = 'RerunTumblingWindowTrigger',
    CustomEvents = 'CustomEventsTrigger',
    ExtensibleTrigger = 'ExtensibleTrigger'
}

export enum TriggerEndOptions {
    None = 'none',
    Occurences = 'occurences',
    Date = 'date'
}

export enum StorageAccountSelectionOptions {
    Azure = 'azure',
    Manual = 'manual'
}

export const triggerTypeMapping: IStringMap<string> = {
    ScheduleTrigger: stringResources.ScheduleTrigger,
    TumblingWindowTrigger: stringResources.TumblingWindowTrigger,
    BlobEventsTrigger: stringResources.BlobEventsTrigger,
    CustomEventsTrigger: stringResources.CustomEventsTrigger,
    ChainingTrigger: stringResources.ChainingTrigger,
    RerunTumblingWindowTrigger: stringResources.RerunTumblingWindowTrigger
};
